import { render, staticRenderFns } from "./PaySellect.vue?vue&type=template&id=3b04a97c&scoped=true&"
import script from "./PaySellect.vue?vue&type=script&lang=js&"
export * from "./PaySellect.vue?vue&type=script&lang=js&"
import style0 from "./PaySellect.vue?vue&type=style&index=0&id=3b04a97c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_uesoswnqfrvbmgjykhrr3r374i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b04a97c",
  null
  
)

export default component.exports